.page-header {
  h1 {
    margin-top: 0;
    margin-bottom: 8px;
    font-size: 48px;
    line-height: 56px;
    font-weight: normal;
  }
  p {
    font-size: 20px;
    line-height: 24px;
    margin-top: 0;
  }

  &--title-center {
    h1 {
      text-align: center;
    }
  }
}
